import * as React from 'react';

import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TooltipHost, TooltipOverflowMode } from 'office-ui-fabric-react/lib';

const styles = require('./ColoredBulletOption.scss');
let classNames = require('classnames/bind').bind(styles);

/**
 *  Interface for the Colored Bullet Option props
 */
export interface ColoredBulletOptionProps {
    color: string;
    label: string;
    iconClassName?: string;
}

/**
 *  This renders a colored bullet with option text.
 */
export default function ColoredBulletOption(props: ColoredBulletOptionProps): JSX.Element {
    return (
        <div className={styles.optionWrapper}>
            <Icon
                className={classNames(styles.coloredBullet, props.iconClassName)}
                style={{ color: props.color }}
                iconName={ControlIcons.CircleFill}
                aria-hidden="true"
            />

            <div className={styles.optionLabel}>
                <TooltipHost
                    id="closeDialogButtonID"
                    content={props.label}
                    overflowMode={TooltipOverflowMode.Parent}
                    calloutProps={{ gapSpace: 0, isBeakVisible: false }}>
                    <span aria-describedby="closeDialogButtonID">{props.label}</span>
                </TooltipHost>
            </div>
        </div>
    );
}
